import {Registration} from '../../data/types/registration/registration';
import {RegistrationFormData} from '../../../components/form/RegisterForm';

export const transformRegistration = (formData: RegistrationFormData): Registration => {

	return {
		uredniNazev: formData.officialName,
		kodPravniFormy: formData.legalForm,
		uzivatel: {
			prihlasovaciJmeno: formData.username,
			jmeno: formData.firstName,
			prijmeni: formData.lastName,
			email: formData.email
		},
		adresa: {
			obec: formData.municipality,
			cisloPopisne: formData.houseNumber,
			cisloOrientacni: formData.orientationNumber,
			psc: formData.zipCode,
			ulice: formData.street,
			stat: formData.state
		},
		...(formData.ico ? {ic: formData.ico} : {})
	};
};
